import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { resetSettingsCache } from "@/hooks/useSettings";

const text = [["company_name", "Company name"], ["tagline", "Tagline"], ["address", "Address"], ["email", "Contact email"], ["phone", "Phone"], ["website", "Website"], ["instagram", "Instagram"]];
const areas = [["min_order_note", "Order units / minimums"], ["pricing_note", "Pricing & availability note"], ["shipping_note", "Shipping & lead-time note"]];
const toggles = [["quotes_enabled", "Quote requests enabled", "Buyers can submit quote lists"], ["show_prices", "Show wholesale prices", "Display configured prices publicly; blank prices still show 'Price on request'"], ["checkout_enabled", "Checkout enabled", "Reserved for Stage 2 — turn on once pricing, stock and shipping are confirmed"], ["samples_available", "Samples available", "Show 'samples on request' messaging"]];

export const SettingsTab = () => {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/settings").then((r) => setS(r.data)); }, []);
  if (!s) return <p className="text-slate-400">Loading…</p>;

  const save = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const { data } = await api.put("/admin/settings", s); setS(data); resetSettingsCache(); toast.success("Settings saved"); }
    catch { toast.error("Save failed"); } finally { setBusy(false); }
  };

  return (
    <form onSubmit={save} className="grid lg:grid-cols-12 gap-6" data-testid="admin-settings-tab">
      <div className="lg:col-span-7 sr-card p-6 grid sm:grid-cols-2 gap-4">
        {text.map(([k, l]) => <label key={k} className="block text-xs font-semibold text-slate-600">{l}<input className="sr-input py-2 mt-1" value={s[k] || ""} onChange={(e) => setS({ ...s, [k]: e.target.value })} data-testid={`settings-${k}`} /></label>)}
        {areas.map(([k, l]) => <label key={k} className="block text-xs font-semibold text-slate-600 sm:col-span-2">{l}<textarea className="sr-input py-2 mt-1 min-h-[70px]" value={s[k] || ""} onChange={(e) => setS({ ...s, [k]: e.target.value })} data-testid={`settings-${k}`} /></label>)}
      </div>
      <div className="lg:col-span-5 space-y-4">
        <div className="sr-card-tint p-6 space-y-4">
          <p className="sr-label">Commerce controls</p>
          {toggles.map(([k, l, d]) => (
            <label key={k} className="flex items-start gap-3 cursor-pointer">
              <input type="checkbox" checked={!!s[k]} onChange={(e) => setS({ ...s, [k]: e.target.checked })} className="mt-1 accent-[#1E7CF2] w-4 h-4" data-testid={`settings-toggle-${k}`} />
              <span><span className="text-sm font-bold text-[#0B1F4B]">{l}</span><br /><span className="text-xs text-slate-600">{d}</span></span>
            </label>
          ))}
        </div>
        <button type="submit" disabled={busy} className="sr-btn-blue w-full justify-center disabled:opacity-60" data-testid="settings-save-button">{busy ? "Saving…" : "Save settings"}</button>
      </div>
    </form>
  );
};
